// #region imports

// --- Angular
import {
  Component,
  Input,
  OnInit,
} from '@angular/core';

// #endregion

@Component({
  selector: 'hs-character-counter',
  templateUrl: './character-counter.component.html',
  styleUrls: ['./character-counter.component.scss']
})
export class CharacterCounterComponent implements OnInit {

  @Input() charsHint: string | null = '';
  @Input() charsRemaining: number = 0;
  @Input() limitReachedText: string | null = '';

  constructor() { }

  ngOnInit() {
  }

}
